export default __webpack_public_path__ + "static/media/provider-icon2.2f790f80.svg";